import fetch from 'auth/FetchInterceptor'

const AuditService = {
  getByDeal: (dealId) =>
    fetch({ url: `/crm/deals/${dealId}/audit`, method: 'get' }),
  getByLead: (leadId) =>
    fetch({ url: `/crm/leads/${leadId}/audit`, method: 'get' }),
}

export default AuditService
